import { render, staticRenderFns } from "./TabsRow.vue?vue&type=template&id=1ee7e7e0&"
import script from "./TabsRow.vue?vue&type=script&lang=ts&"
export * from "./TabsRow.vue?vue&type=script&lang=ts&"
import style0 from "./TabsRow.vue?vue&type=style&index=0&id=1ee7e7e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports